import React from "react"
import SEO from "../components/seo"
import Layout from "../components/layout"
import Header from "../components/header/header"
import Hero from "../components/engaging-menu-page/hero"
import EngagingMenuPageContent from "../components/engaging-menu-page/engagingmenu-page-content"
import StickyNav from "../components/sticky-nav"

const EngagingMenuPage = () => (
    <Layout>
      <SEO title="Engaging Menu" />
      <Header />
      <Hero />
      <EngagingMenuPageContent />
      <StickyNav />
    </Layout>
  )
  
  export default EngagingMenuPage